import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { graphql } from "gatsby";
import Hero from "../components/hero";
import Rich from "../components/rich";
import Title from "../components/title";
import ImageTextBlocks from "../components/image-text-blocks";
import Video from "../components/video";
import ImageLinkBlocks from "../components/image-link-blocks";
import Form from "../components/form";
import Staff from "../components/staff";

const Page = ({ data }) => {
  return (
    <Layout hero={data.contentfulPage.imageVideoOrNone} pageslug={data.contentfulPage.slug}>
      {data.contentfulPage.imageVideoNone === "none" ? (
        <Title
          title={data.contentfulPage.title}
          subtitle={data.contentfulPage.optionalSubtitle}
          background={true}
        />
      ) : data.contentfulPage.imageVideoNone === "image" ? (
        <Hero
          title={data.contentfulPage.title}
          subtitle={data.contentfulPage.optionalSubtitle}
          choice={data.contentfulPage.imageVideoNone}
          imgSrc={data.contentfulPage.headerImageOption.gatsbyImageData}
          imgAlt={data.contentfulPage.headerImageOption.description}
        />
      ) : (
        <Hero
          title={data.contentfulPage.title}
          subtitle={data.contentfulPage.optionalSubtitle}
          src={data.contentfulPage.headerVideoOption}
        />
      )}
      {data.contentfulPage.sections !== null
        ? data.contentfulPage.sections.map((edge, index) =>
            edge.internal.type === "ContentfulText" ? (
              <Rich
                key={edge.id}
                text={edge.content}
                background={edge.backgroundColor}
                section={true}
                left={edge.leftOrCenter}
              />
            ) : edge.internal.type === "ContentfulImageLinkBlocks" ? (
              <ImageLinkBlocks
                key={edge.id}
                title={edge.title}
                half={edge.halfOrThird}
                subtitle={edge.optionalSubtitle}
                background={edge.backgroundColor}
                blocks={edge.imageLinkBlock}
                titleDisplay={edge.titleDisplay}
              />
            ) : edge.internal.type === "ContentfulVideo" ? (
              <Video key={edge.id} link={edge.youTubeLink} title={edge.title} />
            ) : edge.internal.type === "ContentfulForm" ? (
              <Form
                key={edge.id}
                address={edge.address}
                title={edge.title}
                display={edge.titleDisplay}
                formname={edge.formName}
                checkbox={edge.checkbox}
                checkboxItems={edge.checkboxItems}
                textArea={edge.textArea}
              />
            ) : edge.internal.type === "ContentfulImageTextBlocks" ? (
              <ImageTextBlocks
                key={edge.id}
                blocks={edge.blocks}
                background={edge.backgroundColor}
                title={edge.title}
                display={edge.titleDisplay}
                subtitle={edge.subtitle}
              />
            ) : edge.internal.type === "ContentfulStaffSection" ? (
              <Staff
                staff={edge.staffMembers}
                key={edge.id}
                title={edge.title}
                display={edge.tileDisplay}
              />
            ) : (
              ""
            )
          )
        : ""}
    </Layout>
  );
};

export default Page;

export const pageQuery = graphql`
  query pageSlug($slug: String!) {
    contentfulPage(slug: { eq: $slug }) {
      id
      slug
      title
      description
      optionalSubtitle
      imageVideoNone
      headerImageOption {
        description
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
      headerVideoOption
      sections {
        ... on ContentfulText {
          id
          backgroundColor
          internal {
            type
          }
          leftOrCenter
          content {
            raw
            references {
              ... on ContentfulAccordion {
                contentful_id
                title
                internal {
                  type
                }
                accordionSections {
                  id
                  title
                  content {
                    raw
                  }
                }
              }
              ... on ContentfulButton {
                id
                contentful_id
                internal {
                  type
                }
                internalExternal
                internalLink {
                  ... on ContentfulPage {
                    slug
                    internal {
                      type
                    }
                  }
                }
                externalLink
                buttonText
              }
            }
          }
        }
        ... on ContentfulImageLinkBlocks {
          id
          title
          titleDisplay
          halfOrThird
          optionalSubtitle
          backgroundColor
          internal {
            type
          }
          imageLinkBlock {
            description {
              description
            }
            id
            title
            image {
              gatsbyImageData(width: 690)
              description
            }
            externalLink
            internalLink {
              ... on ContentfulPage {
                slug
                internal {
                  type
                }
              }
            }
          }
        }
        ... on ContentfulImageTextBlocks {
          id
          backgroundColor
          subtitle
          title
          titleDisplay
          internal {
            type
          }
          blocks {
            id
            image {
              gatsbyImageData(width: 690)
              description
            }
            text {
              raw
              references {
                ... on ContentfulButton {
                  internal {
                    type
                  }
                  internalExternal
                  internalLink {
                    ... on ContentfulPage {
                      slug
                      internal {
                        type
                      }
                    }
                    ... on ContentfulUniquePage {
                      slug
                      internal {
                        type
                      }
                    }
                  }
                  buttonText
                  contentful_id
                }
              }
            }
          }
        }
        ... on ContentfulVideo {
          id
          youTubeLink
          internal {
            type
          }
          title
        }
        ... on ContentfulForm {
          id
          titleDisplay
          address
          checkbox
          checkboxItems
          formName
          internal {
            type
          }
          textArea
          title
        }
        ... on ContentfulStaffSection {
          id
          internal {
            type
          }
          title
          tileDisplay
          staffMembers {
            id
            name
            role
            email
            picture {
              gatsbyImageData(width: 510)
              description
            }
          }
        }
      }
    }
  }
`;
export const Head = ({ data }) => {
  return (
    <Seo
      title={data.contentfulPage.title}
      description={data.contentfulPage.description}
    />
  );
};
